var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_ed283dfc"]},_vm.$listeners),[_c('cube-button',{attrs:{"icon":"like","inline":"","primary":""}},[_vm._v("With-Icon 按钮")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }